// What the director's "Mark Offer Signed" control shows, and whether it shows
// at all. Kept out of the component so it can be tested on its own
// (offerAttestation.test.js). Returns null when the control is hidden.
//
// IT RECORDS THE OFFER LETTER AND NOTHING ELSE (corrected 2026-10-31). The
// dialog used to promise "offer letter + handbook", the toast said "They can
// now proceed", and the button waited on handbook_acknowledged_at — a field
// nothing has written since 2026-09-14 — so it never hid. Brenda Chamorro
// pressed it five times on Tinayja Summers. The policies are acknowledged by
// the person on their Policies page; a director cannot do it for them, by
// design (no manufactured evidence).
export function offerAttestation(staff, isDirector) {
  if (!isDirector) return null;
  if (staff.offer_letter_signed_at) return null;
  return {
    confirm: `Record ${staff.first_name} ${staff.last_name}'s offer letter as signed?\n\n`
      + 'Use this when their digital signature failed but they meant to sign. '
      + 'The audit trail records it as "director-attested."\n\n'
      + 'This records the offer letter only. The Staff Manual and the Attendance policy '
      + 'are acknowledged by them on their Policies page — a director cannot sign those for them.',
    success: (data) => (data && data.already_recorded
      ? 'Offer letter was already recorded — nothing changed.'
      : 'Offer letter recorded as signed (director-attested).'),
  };
}
